import { Skeleton } from '@monksflow/monks-ui';

import type { ToolbarSkeletonProps } from './ToolbarSkeleton.types';

/**
 * Stands in for a list header: a title on the left, then a search field and an
 * optional action button on the right.
 */
export const ToolbarSkeleton = ({ showButton = true, className }: ToolbarSkeletonProps) => {
  return (
    <div
      role="status"
      aria-busy="true"
      className={`flex flex-row items-center justify-between gap-4 px-8 py-2 ${className ?? ''}`}
    >
      <Skeleton className="h-7 w-35 rounded-md" />
      <div className="flex flex-row items-center gap-4">
        <Skeleton className="h-9 w-50 rounded-md" />
        {showButton && (
          <Skeleton data-testid="toolbar-skeleton-action" className="h-9 w-37.5 rounded-md" />
        )}
      </div>
    </div>
  );
};

ToolbarSkeleton.displayName = 'ToolbarSkeleton';
